{
  "title": "Continual Flame",
  "source": "Player's Handbook",
  "levelAndSchool": "2nd-level evocation",
  "level": 2,
  "castingTime": "1 action",
  "range": "Touch",
  "components": "V, S, M (ruby dust worth 50 gp, which the spell consumes)",
  "duration": "Until dispelled",
  "description": [
    "A flame, equivalent in brightness to a torch, springs forth from an object that you touch. The effect looks like a regular flame, but it creates no heat and doesn’t use oxygen. A continual flame can be covered or hidden but not smothered or quenched."
  ],
  "spellLists": ["artificer", "cleric", "druid", "eldritch-knight", "wizard"]
}
